import styled from "styled-components";
import { VERTICAL_IMAGE_SPEC } from "./../../../../Previews/PostEditors/post-editor-vertical/PostEditorVertical.styled";

export const YOUTUBE_IMAGE_SIZE_SPEC = {
  width: 565,
  pictureWidth: 400,
  minHeight: 209,
  maxHeight: 400
};

export const YOUTUBE_IMAGE_SIZE_SPEC_VERTICAL = {
  width: 360,
  pictureWidth: 360,
  minHeight: 639,
  maxHeight: 639
};

export const HeaderWrapper = styled.div`
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #f5f5f5;
  padding: 10px;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const Logo = styled.img`
  height: 30px;
`;

export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GreyBar = styled.div`
  width: 355px;
  height: 16px;
  border-radius: 50px;
  background-color: #f9f8fb;
  margin-bottom: 8px;
`;

export const Editor = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0px 14px 28px 0px #0000000a;
  margin-bottom: 24px;
  width: ${({ verticalTemplate }) =>
    verticalTemplate ? VERTICAL_IMAGE_SPEC.width : YOUTUBE_IMAGE_SIZE_SPEC.pictureWidth}px;
`;

export const TitleWrapper = styled.div`
  background-color: #302e38;
  width: 100%;
  text-align: left;
  padding: 4px 8px;
`;

export const DescriptionWrapper = styled.div`
  padding: 14px 10px 10px;
`;

export const EditorWrapper = styled.div`
  margin: 0 -4px 10px;
`;

export const EditorFooter = styled.div`
  width: 100%;
  position: relative;
`;

export const CompanyNameWrapper = styled.div`
  display: flex;
`;

export const Sponsored = styled.button`
  background-color: #ffb21c;
  border-radius: 4px;
  border: none;
  padding: 2px 8px 2px 8px;
  color: #fff;
  margin-left: 8px;
  font-size: 8px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.5px;
`;

export const ArrowButton = styled.a`
  position: absolute;
  text-decoration: none;
  right: 0;
  bottom: 0;
  background-color: #302e38;
  border-radius: 100%;
  width: 29px;
  height: 29px;
  border: none;
  padding: 7px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #fff;
    background-color: #26242e;
  }
`;

export const PostEditorWrapper = styled.div`
  width: ${({ verticalTemplate }) =>
    verticalTemplate ? VERTICAL_IMAGE_SPEC.width : YOUTUBE_IMAGE_SIZE_SPEC.width}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: ${({ verticalTemplate }) => (verticalTemplate ? "none" : "#fff")};
  border-radius: 8px;
`;

export const titleStyle = {
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: "21px",
  letterSpacing: "0px",
  color: "#fff"
};

export const teaserTextStyle = {
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "14px",
  letterSpacing: "0px",
  color: "#5F5C70"
};

export const companyNameStyle = {
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0px",
  color: "#5F5C70"
};
